import { atom, useAtomValue } from 'jotai';

// Image base url
export const imageBaseUrlAtom = atom<string | null>(null);
export const useImageBaseUrl = () => {
  const imageBaseUrl = useAtomValue(imageBaseUrlAtom);

  if (!imageBaseUrl) {
    throw new Error('imageBaseUrlAtom is not set');
  }

  return imageBaseUrl;
};

export const blockListClientUrlAtom = atom<string | null>(null);
export const useBlockListClientUrl = () => {
  const blockListClientUrl = useAtomValue(blockListClientUrlAtom);

  if (!blockListClientUrl) {
    throw new Error('blockListClientUrl is not set');
  }

  return blockListClientUrl;
};

// Public Spreadshirt API, called directly from the browser (CORS enabled). Optional: readers
// must cope with null (e.g. Storybook), as it only feeds strike prices.
export const publicApiUrlAtom = atom<string | null>(null);

export const platformAtom = atom<Platform | null>(null);
export const usePlatform = () => {
  const platform = useAtomValue(platformAtom);

  if (!platform) {
    throw new Error('Platform is not set');
  }

  return platform;
};

// Adyen express checkout
export const expressCheckoutConfigAtom = atom<{
  adyenClientKey: string;
  adyenEnvironment: 'test' | 'live';
  backendServiceUrl: string;
} | null>(null);

export const useExpressCheckoutConfig = () => {
  const props = useAtomValue(expressCheckoutConfigAtom);

  if (!props) {
    throw new Error('adyenExpressCheckoutPropsAtom is not set');
  }

  return props;
};
